import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import { Tag as BaseTag } from './base';
export * from './tags';
// export declare class _Tag extends BaseTag<
// TagProps,
// TagEvents,
// TagBlocks
// > { }
// export const Tag = BaseTag as typeof _Tag;
export var Tag = /*#__PURE__*/function (_BaseTag) {
  _inheritsLoose(Tag, _BaseTag);
  function Tag() {
    return _BaseTag.apply(this, arguments) || this;
  }
  return Tag;
}(BaseTag);